// app/javascript/components/shared/ui/Card.js
//
// Surface card. Layout-agnostic — no margin/width; padding is opt-in via the
// `padding` variant so callers that need flush content (tables, lists) can
// keep "none".
import React from "react"
import { cva } from "class-variance-authority"
import clsx from "clsx"

export const cardVariants = cva(
  "bg-white border border-slate-200 rounded-2xl",
  {
    variants: {
      padding: {
        none: "",
        sm:   "p-2",
        md:   "p-3",
        lg:   "p-3",
      },
    },
    defaultVariants: { padding: "none" },
  }
)

const Card = ({ padding, className, as: Tag = "div", ...props }) => (
  <Tag className={clsx(cardVariants({ padding }), className)} {...props} />
)

export default Card
